<template>
  <div class="education">
    <div class="bg-top">
      <div class="banner-bg">
        <img src="../assets/images/顶部banner.gif" alt="" usemap="#image-map">
        <map name="image-map">
          <area target="" alt="" title="" href="javascript:;" @click="openView('科创板')" coords="164,186,104,281" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openView('创业板')" coords="116,414,174,507" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openView('期权')" coords="235,395,316,480" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openView('期货')" coords="513,107,591,215" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openView('基金')" coords="433,534,547,654" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openView('理财')" coords="730,451,834,588" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openDialog(1)" coords="686,660,757,792" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openView('股票')" coords="993,453,1103,583" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openView('新三板')" coords="1193,522,1271,661" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openView('基本面')" coords="1429,95,1349,232" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openView('融资融券')" coords="1471,41,1546,178" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openView('债券')" coords="1582,324,1504,424" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openDialog(1)" coords="1680,392,1629,497" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openView('北交所')" coords="1773,637,1694,760" shape="rect">
          <area target="" alt="" title="" href="javascript:;" @click="openView('价值投资')" coords="1358,722,1437,849" shape="rect">
        </map>
      </div>
    </div>
    <div class="product">
      <!--        <img src="../assets/images/三大产品.png" alt="">-->
      <!--        <img src="../assets/images/标准投教服务图标.gif" alt="">-->
      <!--        <img src="../assets/images/特色投教图标.gif" alt="">-->
      <!--        <img src="../assets/images/定制服务图标.gif" alt="">-->

      <div class="flex">
        <div class="product-box">
          <div class="cp-bg">标准投教产品</div>
          <div class="bd"></div>
          <img class="gif" src="../assets/images/标准投教服务图标.gif" alt="">
          <div class="ab">投教百科库·维度丰富全面</div>
          <div class="intro">满足监管部门，日常投教内容素材全维度，且持续不断更新。</div>
          <div class="ck-detail" @click="openDialog(1)"><img src="../assets/images/detail.png" alt=""></div>
        </div>

        <div class="product-box">
          <div class="cp-bg">特色投教产品</div>
          <div class="bd"></div>
          <img class="gif" src="../assets/images/特色投教图标.gif" alt="">
          <div class="ab">博览原创·适合线上运营服务推广</div>
          <div class="intro">从用户运营角度，策划投教产品，以期达到激活券商存量用户和吸引增量的目的。</div>
          <div class="ck-detail" @click="openDialog(2)"><img src="../assets/images/detail.png" alt=""></div>
        </div>

        <div class="product-box">
          <div class="cp-bg">定制服务</div>
          <div class="bd"></div>
          <img class="gif" src="../assets/images/定制服务图标.gif" alt="">
          <div class="ab">个性化定制·省时省心省力</div>
          <div class="intro">十多年金融机构服务经验，一站式满足各种投教需求。</div>
          <div class="ck-detail" @click="onInitDialog"><img src="../assets/images/detail.png" alt=""></div>
        </div>
      </div>
    </div>
    <div class="support">
      <img src="../assets/images/技术支持动态图.gif" alt="">
    </div>
    <div class="service">
      <img src="../assets/images/服务保障动态图.gif" alt="">
    </div>
    <div class="success-case">
      <div class="case-title"><img src="../assets/images/成功案例.png" alt=""></div>
    </div>
    <div class="customer">
      <div class="red" @click="changeActiveName('first')"><img src="../assets/images/gtja.png" alt=""></div>
      <div class="red" @click="changeActiveName('second')"><img src="../assets/images/swhy.png" alt=""></div>
      <div class="red" @click="changeActiveName('third')"><img src="../assets/images/zxjt.png" alt=""></div>
      <div class="red" @click="changeActiveName('fourth')"><img src="../assets/images/zszq.png" alt=""></div>
    </div>
    <div class="customer-two">
      <div class="red" @click="changeActiveName('five')"><img src="../assets/images/gyzq.png" alt=""></div>
      <div class="red" @click="changeActiveName('six')"><img src="../assets/images/hazq.png" alt=""></div>
      <div class="red" @click="changeActiveName('seven')"><img src="../assets/images/zyzq.png" alt=""></div>
      <div class="red" @click="changeActiveName('eight')"><img src="../assets/images/zhzq.png" alt=""></div>
    </div>

    <el-dialog title="成功案例" :visible.sync="dialogVisibles" class="roll-dialog" width="1100px" center>
      <el-tabs v-model="activeName" stretch @tab-click="handleClick">
        <el-tab-pane label="国泰君安" name="first">
          <div class="case-img"><a target="_blank" href="http://rzrq.bolanjr.com/static/%E5%9B%BD%E6%B3%B0%E5%90%9B%E5%AE%89APP.mp4"><img src="../assets/images/国泰君安证券.png" alt=""></a></div>
        </el-tab-pane>
        <el-tab-pane label="申万宏源证券" name="second">
          <a target="_blank" href="http://rzrq.bolanjr.com/static/%E7%94%B3%E4%B8%87%E5%AE%8F%E6%BA%90APP.mp4"><div class="sp"></div></a>
          <div class="case-img"><img src="../assets/images/申万宏源证券.png" alt=""></div>
        </el-tab-pane>
        <el-tab-pane label="中信建投证券" name="third">
          <a target="_blank" href="http://rzrq.bolanjr.com/static/%E4%B8%AD%E4%BF%A1%E5%BB%BA%E6%8A%95app.mp4"><div class="sp"></div></a>
          <a target="_blank" href="https://investedu.csc108.com/pages/database1/zlk.html"><div class="href"></div></a>
          <div class="case-img"><img src="../assets/images/中信建投.png" alt=""></div>
        </el-tab-pane>
        <el-tab-pane label="招商证券" name="fourth">
          <div class="case-img"><img src="../assets/images/招商证券.png" alt=""></div>
        </el-tab-pane>
        <el-tab-pane label="国元证券" name="five">
          <a target="_blank" href="http://rzrq.bolanjr.com/static/%E5%9B%BD%E5%85%83%E8%AF%81%E5%88%B8app.mp4"><div class="sp"></div></a>
          <a target="_blank" href="http://tjjd.gyzq.com.cn/tj/knowledge/novice/shares/index.shtml"><div class="hrefs"></div></a>
          <div class="case-img">><img src="../assets/images/国元证券.png" alt=""></div>
        </el-tab-pane>
        <el-tab-pane label="华安证券" name="six">
          <a target="_blank" href="http://rzrq.bolanjr.com/static/%E5%8D%8E%E5%AE%89app02.mp4"><div class="sp"></div></a>
          <a target="_blank" href="http://www.hatjedu.com/front/views/main/tjcp/img-text/hxahxx/index.shtml"><div class="hrefs"></div></a>
          <div class="case-img"><img src="../assets/images/华安证券.png" alt=""></div>
        </el-tab-pane>
        <el-tab-pane label="中邮证券" name="seven">
          <div class="case-img"><a target="_blank" href="http://rzrq.bolanjr.com/static/%E4%B8%AD%E9%82%AE%E8%AF%81%E5%88%B8app.mp4"><img src="../assets/images/中邮证券.png" alt=""></a></div>
        </el-tab-pane>
        <el-tab-pane label="中航证券" name="eight">
          <div class="case-img"><a target="_blank" href="http://tjjd.avicsec.com/main/zhkj/zhts/index.shtml"><img src="../assets/images/中航证券.png" alt=""></a></div>
        </el-tab-pane>
      </el-tabs>
      <!--        <div class="case-img"><img src="../assets/images/imgBg.png" alt=""></div>-->
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" width="1100px" class="bord" :before-close="handleClose">
      <div>
        <div class="titleText">{{titleText}}</div>
        <div class="titleSecondText" v-if="isShowTips">
          {{tipText}}
        </div>
        <div class="butImage" v-if="titleText == '定制服务类型'">
          <button class="butImage1" style=" margin-top: 352px;margin-left: 110px;" @click="onBut01(1)"></button>
          <button class="butImage1" style=" margin-top: 352px;margin-left: 265px;" @click="onBut01(2)"></button>
        </div>

        <div v-if="titleText == '参赛作品定制-案例'" :style="{'background-image': `url(${require('../assets/images/定制服务成功案例.png')})`}" style=" width: 1006px;height: 431px;margin: 0 auto;">
          <button class="butImage2" @click="onBut01(3)"></button>
          <button class="butImage2" style="margin-left:19px" @click="onBut01(4)"></button>
          <button class="butImage2" style="margin-left:18px" @click="onBut01(5)"></button>
        </div>

        <div v-if="titleText == '动态漫画-优秀奖'">
          <el-carousel :interval="9000" trigger="click" height="505px" style="width:460px; margin:0 auto;">
            <el-carousel-item v-for="item in goodImages" :key="item">
              <el-image style="width: 460px; height: 505px; margin: 0 auto;" :src="require('../assets/'+item)"></el-image>
            </el-carousel-item>

          </el-carousel>
          <div style="margin: 10px auto 0px;text-align: center; height: 20px; color: rgba(16, 16, 16, 1); font-size: 14px; font-family: SourceHanSansSC-regular;">共3张</div>
        </div>

        <div v-if="titleText == '微电影-卓越奖'">
          <div style="width:895px; height:505px; margin: 0 auto;">
            <video style="width:895px; height:505px; margin: 0 auto;" playsinline="" controls="" disablepictureinpicture="" controlslist=" nodownload">
              <source :src="require('../assets/images/微电影.mp4')">Video element is not supported in this browser.
            </video>
          </div>
        </div>

        <div v-if="titleText == 'MG动画-二等奖'">
          <div style="width:895px; height:505px; margin: 0 auto;">
            <video style="width:895px; height:505px; margin: 0 auto;" playsinline="" controls="" disablepictureinpicture="" controlslist=" nodownload">
              <source :src="require('../assets/images/MG动画.mp4')">Video element is not supported in this browser.
            </video>
          </div>
        </div>

        <div class="activeDesign" v-if="titleText == '活动策划案例'">
          <div v-if="isShowVideo1" style="width:895px; height:505px; margin: 0 auto;">
            <video style="width:895px; height:505px; margin: 0 auto;" playsinline="" controls="" disablepictureinpicture="" controlslist=" nodownload">
              <source :src="require('../assets/images/竖版视频.MP4')">Video element is not supported in this browser.
            </video>
          </div>
          <div v-if="isShowVideo2" style="width:895px; height:505px; margin: 0 auto;">
            <video style="width:895px; height:505px; margin: 0 auto;" playsinline="" controls="" disablepictureinpicture="" controlslist=" nodownload">
              <source :src="require('../assets/images/横版视频.mp4')">Video element is not supported in this browser.
            </video>
          </div>
          <div v-if="isShowDiv" style="width: 1020px; height: 510px; margin: 0 auto 30px;background-repeat: no-repeat" :style="{'background-image': `url(${require('../assets/images/活动策划案例.png')})`}">
            <div ref="活动策划案例"></div>
            <el-image class="hiddenBtn" style="width: 240px;height: 158px;margin-left: 167px;margin-top: 332px;" :src="require('../assets/images/transparent.png')" :preview-src-list="[require('../assets/images/活动策划案例01.png')]">
            </el-image>
            <el-image class="hiddenBtn" style="width: 70px;height: 130px;margin-left: 50px;margin-top: 332px;" :src="require('../assets/images/transparent.png')" :preview-src-list="[require('../assets/images/515防范非法活动宣传月.jpg')]">
            </el-image>
            <button class="hiddenBtn" @click="onBut02(3)" style="width: 80px;height: 130px;margin-left: 8px;margin-top: 332px;"></button>
            <button class="hiddenBtn" @click="onBut02(4)" style="width: 80px;height: 130px;margin-left: 2px;margin-top: 332px;"></button>
            <el-image class="hiddenBtn" style="width: 110px;height: 160px;margin-left: 109px;margin-top: 332px;" :src="require('../assets/images/transparent.png')" :preview-src-list="[require('../assets/images/活动策划案例03.jpg')]">
            </el-image>
            <!-- <div class="hiddenBtn" @click="onBut02(2)" style="width: 70px;height: 130px;margin-left: 50px;margin-top: 332px;"></div>
  <div class="hiddenBtn" @click="onBut02(3)" style="width: 80px;height: 130px;margin-left: 8px;margin-top: 332px;"></div>
  <div class="hiddenBtn" @click="onBut02(4)" style="width: 80px;height: 130px;margin-left: 2px;margin-top: 332px;"></div>
  <div class="hiddenBtn" @click="onBut02(5)" style="width: 110px;height: 160px;margin-left: 109px;margin-top: 332px;"></div> -->
          </div>
        </div>
      </div>

    </el-dialog>


    <div class="toujiaoDialog">
      <el-dialog :title="dialogtitle" :visible.sync="divlogVisible" :before-close="toujiaoClose" width="1100px" class="product-dialog">
        <el-row :gutter="20" style="margin-top: -20px;">
          <el-col :span="8" :offset="8">
            <div class="bg-purple" @click="showTotal()">{{dialoglabel}}</div>
          </el-col>
        </el-row>
        <div class="divbtn" v-show="dialogshow2" :style="{'background-image': `url(${require('@/assets/tj001.png')})`,'background-repeat':'no-repeat'}">
          <div class="divbtns">
            <div @click="openView('看热点学知识')" class="dd2"><span v-show="token ? show1: show2">{{krdxzArr[0]}}</span></div>
            <div @click="openView('投资行为')" class="dd2"><span v-show="token ? show1: show2">{{tzxwArr[0]}}</span></div>
            <div @click="openView('vs对比系列')" class="dd2"><span v-show="token ? show1: show2">{{dbxlArr[0]}}</span></div>
            <div @click="openView('趣味金融')" class="dd2"><span v-show="token ? show1: show2">{{qwjrArr[0]}}</span></div>
          </div>
        </div>

        <div class="divbtn" v-show="dialogshow1" :style="{'background-image': `url(${require('@/assets/jctj001.png')})`,'background-repeat':'no-repeat'}">
          <div class="divbtns">
            <div class="dd1">
              <el-row class="rowtitle pos"><span v-show="token ? show1: show2">{{jtpArr[0]}}</span></el-row>
              <div @click="openView('宏观分析')"><el-row class="row1"><span v-show="token ? show1: show2">{{jtpArr[1]}}</span></el-row></div>
              <div @click="openView('行业分析')"><el-row class="row1"><span v-show="token ? show1: show2">{{jtpArr[2]}}</span></el-row></div>
              <div @click="openView('公司分析')"><el-row class="row1"><span v-show="token ? show1: show2">{{jtpArr[3]}}</span></el-row></div>
            </div>
            <div class="dd1">
              <el-row class="rowtitle pos"><span v-show="token ? show1: show2">{{jsfxArr[0]}}</span></el-row>
              <div @click="openView('K线')"><el-row class="row2"><span v-show="token ? show1: show2">{{jsfxArr[1]}}</span></el-row></div>
              <div @click="openView('技术指标')"><el-row class="row2"><span v-show="token ? show1: show2">{{jsfxArr[2]}}</span></el-row></div>
              <div @click="openView('趋势形态分析')"><el-row class="row2"><span v-show="token ? show1: show2">{{jsfxArr[3]}}</span></el-row></div>
              <div @click="openView('均线')"><el-row class="row2"><span v-show="token ? show1: show2">{{jsfxArr[4]}}</span></el-row></div>
              <div @click="openView('分时量价')"><el-row class="row2"><span v-show="token ? show1: show2">{{jsfxArr[5]}}</span></el-row></div>
              <div @click="openView('方法论/策略')"><el-row class="row2"><span v-show="token ? show1: show2">{{jsfxArr[6]}}</span></el-row></div>
            </div>
            <div class="dd1" style="width: 260px;">
              <el-row class="rowtitle pos"><span v-show="token ? show1: show2">{{jrpzArr[0]}}</span></el-row>
              <el-row>
                <div @click="openView('股票')">
                  <el-col :span="11" class="row3"><span v-show="token ? show1: show2">{{jrpzArr[1]}}</span></el-col></div>
                <el-col style="width:10px;"></el-col>
                <div @click="openView('基金')">
                  <el-col :span="11" class="row3"><span v-show="token ? show1: show2">{{jrpzArr[2]}}</span></el-col></div>
              </el-row>
              <el-row>
                <div @click="openView('期权')">
                  <el-col :span="11" class="row3"><span v-show="token ? show1: show2">{{jrpzArr[3]}}</span></el-col></div>
                <el-col style="width:10px;"></el-col>
                <div @click="openView('期货')">
                  <el-col :span="11" class="row3"><span v-show="token ? show1: show2">{{jrpzArr[4]}}</span></el-col></div>
              </el-row>
              <el-row>
                <div @click="openView('债券')">
                  <el-col :span="11" class="row3"><span v-show="token ? show1: show2">{{jrpzArr[5]}}</span></el-col></div>
                <el-col style="width:10px;"></el-col>
                <div @click="openView('科创板')">
                  <el-col :span="11" class="row3"><span v-show="token ? show1: show2">{{jrpzArr[6]}}</span></el-col></div>
              </el-row>
              <el-row>
                <div @click="openView('新三板')">
                  <el-col :span="11" class="row3"><span v-show="token ? show1: show2">{{jrpzArr[7]}}</span></el-col></div>
                <el-col style="width:10px;"></el-col>
                <div @click="openView('创业板')">
                  <el-col :span="11" class="row3"><span v-show="token ? show1: show2">{{jrpzArr[8]}}</span></el-col></div>
              </el-row>
              <el-row>
                <div @click="openView('北交所')">
                  <el-col :span="11" class="row3"><span v-show="token ? show1: show2">{{jrpzArr[9]}}</span></el-col></div>
                <el-col style="width:10px;"></el-col>
                <div @click="openView('投资理财')">
                  <el-col :span="11" class="row3"><span v-show="token ? show1: show2">{{jrpzArr[10]}}</span></el-col></div>
              </el-row>
              <div @click="openView('融资融券')">
                <el-row class="row2" style="width:220px;"><span v-show="token ? show1: show2">{{jrpzArr[11]}}</span></el-row></div>
            </div>
            <div class="dd1">
              <el-row class="rowtitle pos"><span v-show="token ? show1: show2">{{szjqArr[0]}}</span></el-row>
              <div @click="openView('主题投资')"><el-row class="row4"><span v-show="token ? show1: show2">{{szjqArr[1]}}</span></el-row></div>
              <div @click="openView('风险地雷')"><el-row class="row4"><span v-show="token ? show1: show2">{{szjqArr[2]}}</span></el-row></div>
              <div @click="openView('买卖技巧')"><el-row class="row4"><span v-show="token ? show1: show2">{{szjqArr[3]}}</span></el-row></div>
              <div @click="openView('价值投资')"><el-row class="row4"><span v-show="token ? show1: show2">{{szjqArr[4]}}</span></el-row></div>
            </div>
            <div class="dd1">
              <el-row class="rowtitle pos"><span v-show="token ? show1: show2">{{fxjyArr[0]}}</span></el-row>
              <div @click="openView('政策法规')"><el-row class="row5"><span v-show="token ? show1: show2">{{fxjyArr[1]}}</span></el-row></div>
              <div @click="openView('典型案例')"><el-row class="row5"><span v-show="token ? show1: show2">{{fxjyArr[2]}}</span></el-row></div>
              <div @click="openView('防骗攻略')"><el-row class="row5"><span v-show="token ? show1: show2">{{fxjyArr[3]}}</span></el-row></div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

    <div class="innerDialogs">
      <el-dialog :visible.sync="innerVisible" :before-close="innerClose" width= "100%" id="dia">
        <div @click="inner1()">
          <div class="baseEdu" v-if="innersrc==''||innersrc==null" :style="{'background-image': `url(${require('@/assets/not001.png')})`,'background-repeat':'no-repeat','background-position':'center center'}"></div>
          <div class="baseEdu" v-else>
            <div style="width:400px;" @click="inner2()">
              <el-image style="width:400px;max-height:670px;border-radius:20px 0 0 20px;" fit="cover" :src="innersrc"></el-image>
              <div class="zhezhao">
                <el-image style="width:145px;height:49px;margin-top:316px;margin-left:126px;" :src="require('@/assets/bg002.png')" :preview-src-list="srcList"></el-image>
              </div>
            </div>
            <div style="width:360px;" @click="inner3()">
              <div style="padding:20px 25px;text-align: left;">
                <div class="innerTitle"> {{titleTexts}}</div>
                <div style="height:30px;padding-top: 23px;" v-if="tagnamesText!=null"><span style="color: rgba(159, 159, 159, 1);margin-right: 5px;">标签: </span><span class="tag-bg">{{tagnamesText}}</span></div>
                <div style="padding-bottom: 15px;margin-top:23px;">
                  <span class="xgal">相关样例</span>
                  <span style="color:#BFBFBF;font-size:12px;">点击下方蓝色的文字可查看相关样例</span>
                </div>
                <div style="overflow:auto;max-height: 425px;">
                <div class="titleDiv" v-if="titleArr.length > 0 " v-for="(value, key) in titleArr" @click="doChange(key,1)">{{ value.sample_title }}</div>
                  <div style="width: 100%;height: 300px" v-if="titleArr.length === 0 " :style="{'background-image': `url(${require('@/assets/not001.png')})`,'background-repeat':'no-repeat','background-position':'center center'}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="background: #F3F4FD;padding-bottom: 20px;">
          <div style="font-size:18px;color:#101010;padding:26px 26px 0 26px;text-align: center;font-weight: bold;">{{srctagname}}
            <div style="width:40px;height:4px;background: #2381EF;margin:15px auto;"></div></div>
          <div style="width:1200px;min-height:360px;text-align:center;margin:0 auto 30px;">
            <el-image class="imageDiv" fit="cover" v-for="(value, key) in imageSrc" :key="key" :src="value.sample_path" @click="doChange(key,2)" lazy>
            </el-image>
          </div>
        </div>
      </el-dialog>
    </div>


  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "Education",
  data() {
    return {
      dialogVisibles: false,
      activeName: 'first',
      idVideoShowUrl: '',
      videoUrlArr: ['../assets/images/MG动画.mp4', '../assets/images/MG动画.mp4'],
      isShowVideo1: false,
      isShowVideo2: false,
      isShowDiv: true,
      goodImages: ['images/地球守护.gif', 'images/粮食守护.gif', 'images/疫情守护.gif'],
      fit: 'cover',
      isShowTips: true,
      titleText: '定制服务类型',
      dialogVisible: false,
      dialogtitle:'',
      dialoglabel:'',
      catname:'',
      titleTexts: '',
      tipText: '点击下方蓝色按钮可查看相关样例',
      tagnamesText: '',
      titleArr:[],
      titleSrc:[],
      imageArr:[],
      imageCate:[],
      imageSrc:[],
      srcList:[],
      srctagname:'',
      divlogVisible: false,
      innerVisible: false,
      dialogshow1: false,
      dialogshow2: false,
      innersrc:"",
      show1:true,
      show2:false,
      token: false,
      islitter: false,
      jtpArr:[0,0,0,0],
      jsfxArr:[0,0,0,0,0,0,0],
      jrpzArr:[0,0,0,0,0,0,0,0,0,0,0,0],
      szjqArr:[0,0,0,0,0],
      fxjyArr:[0,0,0,0],
      krdxzArr:[0,0],
      tzxwArr:[0,0],
      dbxlArr:[0,0],
      qwjrArr:[0,0],
      tName:[],
      allTagName:[],
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    changeActiveName(i) {
      this.dialogVisibles = true
      this.activeName = i
    },
    onInitDialog() {
      this.titleText = '定制服务类型';
      this.dialogVisible = true;
    },
    onBut01(index) {
      this.isShowVideo = false;
      switch (index) {
        case 1: this.titleText = '参赛作品定制-案例';
        this.tipText = '点击下方图片可查看相关样例'
          break;
        case 2: this.titleText = '活动策划案例';
          break;
        case 3: this.titleText = '动态漫画-优秀奖';
          break;
        case 4: this.titleText = '微电影-卓越奖';
          break;
        case 5: this.titleText = 'MG动画-二等奖';
          break;
      }
      if (index != 1) {
        this.isShowTips = false;
      }
    },

    completeVideoUrl(url) {
      return '<video style="width:895px; height:505px; margin: 0 auto;" playsinline="" controls="" disablepictureinpicture="" controlslist=" nodownload"> <source src="' + url + '">Video element is not supported in this browser. </video>'
    },

    onBut02(index) {
      switch (index) {
        case 3: {
          this.isShowVideo1 = true;
          this.isShowDiv = false;
        }
          break;
        case 4: {
          this.isShowVideo2 = true;
          this.isShowDiv = false;
        }
          break;
      }
    },
    inner1(){
      if(this.islitter==false){
        this.innerVisible=false
        this.divlogVisible=true
      }
      this.islitter=false
    },
    inner2(){
      this.islitter=true
    },
    inner3(){
      this.islitter=true
    },
    handleClose(done) {
      if (this.titleText != '定制服务类型') {
        this.tipText='点击下方蓝色按钮可查看相关样例'
        if (this.titleText == '动态漫画-优秀奖' || this.titleText == '微电影-卓越奖' || this.titleText == 'MG动画-二等奖') {
          this.titleText = '参赛作品定制-案例';
          this.isShowTips = true;
        } else if (this.titleText == '活动策划案例') {
          this.titleText = '定制服务类型';
          this.isShowTips = true;
        } else if (this.titleText == '参赛作品定制-案例') {
          this.titleText = '定制服务类型';
          this.isShowTips = true;
        }
      } else {
        this.dialogVisible = false;
      }
      if (this.isShowVideo1 == true || this.isShowVideo2 == true) {
        this.isShowVideo1 = false;
        this.isShowVideo2 = false;
        this.isShowDiv = true;
        this.titleText = '活动策划案例';
      }
    },
    showTotal(){
      if(this.dialogshow1){
        var url="http://47.92.215.85:8000/api1/tjproduct/?type=1";
      }
      if(this.dialogshow2){
        var url="http://47.92.215.85:8000/api1/tjproduct/?type=0";
      }
      var username = window.localStorage.getItem('username')?window.localStorage.getItem('username'):''
      if(username!=null){
        url += "&username="+username
        this.$axios({ url: url, method: "get", params: {} }).then((response) => {
          if(response.data.msg=='Success'){
            var res = response.data.data[0]
            if(this.dialogshow1){
              this.jtpArr = res.jtp
              this.jsfxArr = res.jsfx
              this.jrpzArr = res.jrpz
              this.szjqArr = res.szjq
              this.fxjyArr = res.fxjy
            }
            if(this.dialogshow2){
              this.krdxzArr = res.krdxz
              this.tzxwArr = res.tzxw
              this.dbxlArr = res.dbxl
              this.qwjrArr = res.qwjr
            }
            this.token = true
            console.log(333,response)
          }
        })
      }
    },
    openDialog(res){
      this.divlogVisible = true
      if(res==1){
        this.dialogshow2 = false
        this.dialogshow1 = true
        this.dialogtitle = '标准投教产品-内容体系'
        this.dialoglabel = '点击下方蓝色的文字可查看相关样例'
        this.srctagname = '标准投教最新样例'
      }
      if(res==2){
        this.dialogshow1 = false
        this.dialogshow2 = true
        this.dialogtitle = '特色投教产品-内容体系'
        this.dialoglabel = '点击下方图片可查看相关样例'
        this.srctagname = '特色投教最新样例'
      }
    },
    openView(res){
      this.divlogVisible = false
      this.innerVisible = true
      if(res=='看热点学知识'||res=='投资行为'||res=='vs对比系列'||res=='趣味金融'){
        var url ='http://47.92.215.85:8000/api1/latestsample/?name='+res+'&type=0';
      }else{
        var url ='http://47.92.215.85:8000/api1/latestsample/?name='+res+'&type=1';
      }
      this.$axios({
        url: url,
        method: "get",
        params: {}
      }).then((response) => {
        console.log(response);
        var dd = response.data.data
        console.log(dd);
        if(dd !== undefined){
          if(dd.length>0){
            this.catname = res
            this.titleTexts = res +' | '+ dd[0].title
            this.tagnamesText = dd[0].tagname
            this.innersrc = dd[0].path
            this.titleArr = dd[0].data
            this.tName = dd[0].data
            this.titleSrc = dd[0].data
            this.allTagName = response.data.all_data
            this.imageArr = response.data.all_data
            this.imageSrc = response.data.all_data
            this.imageCate = response.data.all_data
            this.srcList = [];
            this.srcList.push(this.innersrc)
          }
        }else if(dd === undefined){
          this.catname = ''
          this.titleTexts = ''
          this.tagnamesText = ''
          this.innersrc = ''
          this.titleArr = ''
          this.tName = ''
          this.titleSrc = ''
          this.allTagName = ''
          this.imageArr = ''
          this.imageSrc = ''
          this.imageCate = ''
        }
      })
    },
    doChange(key,arg){
      console.log(this.titleArr[key]);
      if(arg==1){
        this.titleTexts = this.catname +' | '+ this.titleArr[key].sample_title
        this.innersrc = this.titleSrc[key].sample_path
        this.tagnamesText = this.tName[key].sample_tagnames
      }
      if(arg==2){
        var res = this.imageCate[key].sample_name
        var url ='http://47.92.215.85:8000/api1/latestsample/?name='+res+'&type=1';
        this.$axios({
          url: url,
          method: "get",
          params: {}
        }).then((response) => {
          var dd = response.data.data
          if(dd.length>0){
            this.catname = res
            this.titleArr = dd[0].sample_title
            this.titleSrc = dd[0].sample_path
          }
        })
        this.titleTexts = this.catname +' | '+ this.imageArr[key].sample_title
        this.innersrc = this.imageSrc[key].sample_path
        this.tagnamesText = this.allTagName[key].sample_tagnames
      }
      this.srcList = [];
      this.srcList.push(this.innersrc)
      let ele = document.getElementById('dia');
      ele.scrollTop = 0;
    },
    innerClose(){
      this.innerVisible = false
      this.divlogVisible = true
    },
    toujiaoClose(){
      this.token = false
      this.divlogVisible = false
    }
  }
}
</script>
<style scoped>
>>>.roll-dialog .el-dialog__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(100vh - 260px);
}

>>>.roll-dialog .el-dialog__title{
  font-size: 36px!important;
}

>>>.product-dialog .el-dialog__title{
  font-size: 36px!important;
}

>>>.product-dialog .el-dialog__header{
  padding: 30px 20px 10px;
}

>>>.roll-dialog .el-dialog__header{
  padding: 30px 20px 10px;
}

>>>.roll-dialog .el-dialog{
  margin-top: 8vh!important;
}

>>>.bord .el-dialog__body{
  padding: 30px 20px 40px;
}

>>>.el-dialog {
  border-radius: 20px;
}

.el-carousel__item {
  width: 480px;
}

>>>.toujiaoDialog .el-dialog__headerbtn .el-dialog__close {
  color: black;
  background-color: white;
}

>>>.bord .el-dialog__headerbtn .el-dialog__close {
  color: black;
  background-color: white;
}

>>>.roll-dialog .el-dialog__headerbtn .el-dialog__close {
  color: black;
  background-color: white;
}

.tag-bg{
  border-radius: 60px;
  background-color: rgba(255, 235, 227, 1);
  color: rgba(255, 111, 54, 1);
  font-size: 12px;
  text-align: center;
  padding: 4px 8px;
  font-family: Microsoft Yahei;
}

.bg-top{
  margin-top: 50px;
}

.titleText {
  color: rgb(0, 0, 0);
  font-size: 36px;
  margin: -33px auto 19px;
  text-align: center;
  font-weight: 600;
  font-family: SourceHanSansSC-bold;
}
.titleSecondText {
  width: 309px;
  height: 36px;
  margin: 0 auto 35px;
  line-height: 40px;
  border-radius: 18px;
  background-color: rgba(255, 230, 207, 1);
  color: rgba(255, 150, 6, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
}
.butImage1 {
  width: 180px;
  height: 44px;
  background-color: rgba(0, 0, 0, 0);
  border-color: rgba(0, 0, 0, 0);
}
.butImage2 {
  width: 320px;
  height: 250px;
  background-color: rgba(0, 0, 0, 0);
  border-color: rgba(0, 0, 0, 0);
}
.butImage {
  background-image: url(../assets/images/tp3.png);
  width: 848px;
  height: 426px;
  margin: 0 auto;
}

.exampleDivTop {
  width: 320px;
  height: 190px;
  border-radius: 20px 20px 0px 0px;
}
.exampleDivBottom {
  width: 318px;
  height: 189px;
  background-color: white;
  border-radius: 0px 0px 10px 10px;
  border: 1px solid rgba(236, 237, 237, 1);
}
.exampleTitle {
  text-align: center;
  margin: 39px 0 22px;
  color: rgba(16, 16, 16, 1);
  font-size: 20px;
  font-weight: 550;
  font-family: SourceHanSansSC-bold;
}
.exampleText {
  text-align: center;
  color: rgba(16, 16, 16, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-regular;
}
.exampleImage {
  width: 657px;
  height: 505px;
  margin: 0 auto;
}
.activeDesign {
  border-radius: 10px;
  line-height: 50px;
}
.hiddenBtn {
  background-color: rgba(0, 0, 0, 0);
  border-color: rgba(0, 0, 0, 0);
}
.bg-top img {
  width: 100%;
}

.banner-bg {
  /*width: 1200px;*/
  /*margin: 0 auto;*/
}

.product {
  width: 100%;
  text-align: center;
}

.support {
  width: 100%;
  text-align: center;
  margin-bottom: 30px;
  margin-top: 80px;
}

.service {
  width: 100%;
  background-color: #4d60ef;
  text-align: center;
}

.service img{
  padding: 40px 0;
}

.success-case {
  margin: 60px 0;
}

.case-title {
  text-align: center;
}

.customer {
  width: 1100px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
}

.customer-two {
  width: 1100px;
  display: flex;
  flex-wrap: wrap;
  margin: 24px auto 40px;
}

.red {
  flex: 1;
  height: 70px;
  cursor: pointer;
}

.red + .red {
  margin-left: 20px;
}

.case-img {
  width: 100%;
  text-align: center;
}

>>> .el-tabs__nav-scroll {
  width: 100%;
  margin: 20px auto 0;
}

>>>.el-tab-pane {
  position: relative;
  height: calc(100vh - 110px);
  overflow-y: auto;
}

.sp{
  position: absolute;
  z-index: 99;
  height: 565px;
  width: 100%;
}

.href{
  position: absolute;
  width: 100%;
  top: 640px;
  height: 450px;
}

.hrefs {
  position: absolute;
  width: 100%;
  top: 1100px;
  height: 450px;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

>>> .el-tabs__content {
  padding: 10px;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: rgba(255, 255, 255, 100);
  color: rgba(97, 154, 241, 100);
}

>>> .el-tabs__nav-wrap:after {
  background-color: transparent;
}

>>> .el-tabs__active-bar {
  background-color: transparent;
}

>>> .el-tabs__item {
  border-radius: 10px;
  font-size: 14px;
  margin: 0 5px;
  background-color: rgba(255, 255, 255, 1);
  color: rgba(35, 129, 254, 1);
}

>>> .el-tabs__item.is-active {
  background-color: rgba(35, 129, 254, 1);
  color: rgba(255, 255, 255, 1);
}

>>> .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px;
}

>>> .el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 20px;
}

.product {
  margin-bottom: 25px;
  margin-top: -100px;
}

.flex {
  display: flex;
  margin: 0 auto;
  width: 1100px;
}

.product-box {
  background-color: white;
  border-radius: 20px;
  position: relative;
  flex: 1;
  width: 345px;
  height: 450px;
  box-shadow: 0 0 10px 5px rgba(77, 96, 239, 0.2);
}

.bd{
  position: absolute;
  width: 165px;
  height: 165px;
  border-radius: 100%;
  left: 94px;
  top: 77px;
  background-color: #4A63EF;
}

.product-box .gif{
  position: relative;
  left: 77px;
  display: block;
  z-index: 1;
}

.product-box + .product-box {
  margin-left: 20px;
}

.ab {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.intro {
  text-align: left;
  font-size: 14px;
  padding-bottom: 20px;
  margin: 0 30px;
  line-height: 1.6em;
  color: #bababa;
}

.cp-bg {
  height: 60px;
  line-height: 60px;
  border-radius: 0 0 20px 20px;
  margin: 0 20px;
  color: white;
  font-size: 26px;
  font-weight: bold;
  background-image: linear-gradient(#5866f0, #3b4ae5);
}

.ck-detail img {
  position: relative;
  top: -5px;
}

.dd1 span{
  width:20px;
  height:20px;
  line-height:18px;
  color:#FFFFFF;
  font-size:12px;
  text-align:center;
  border-radius: 20px;
  background-color:#FFBE06;
  display: inline-block;
}
.dd2 span{
  width:48px;
  height:22px;
  line-height:22px;
  color:#FFFFFF;
  font-size:14px;
  text-align:center;
  border-radius: 10px;
  background-color:#4B6EFE;
  display: inline-block;
  position: relative;
  top: 360px;
}
.pos{
  position: relative;
  top: 50px;
  text-align: center;
}
.pos span{
  width:48px;
  height:22px;
  line-height:22px;
  color:#FFFFFF;
  font-size:14px;
  text-align:center;
  border-radius: 10px;
  background-color:#4B6EFE;
  display: inline-block;
}
.bg-purple {
  background: #FFE6CF;
  color:#FF9606;
  font-size: 14px;
  min-height: 28px;
  margin: 0px 15px;
  line-height: 36px;
  border-radius: 18px;
  cursor: pointer;
  text-align: center;
}
.divbtn {
  background:rgba(255,255,255,0);
  height:440px;
  margin-top: 35px;
  margin-left:20px;
}
.divbtns {
  background:rgba(255,255,255,0);
  height:440px;
  margin-top: 35px;
  display:flex;
}
.divbtn .dd1 {
  background: rgba(255,255,255,0);
  width: 180px;
  height:400px;
  border-radius: 20px;
  margin-left: 10px;
}
.divbtn .dd2 {
  background: rgba(255,255,255,0);
  width: 230px;
  height:420px;
  border-radius: 20px;
  margin-left: 31px;
  cursor: pointer;
  text-align: center;
}
.divbtn .dd2:nth-child(1) {
  margin-left: 0px;
}
.rowtitle{
  height: 92px;
  padding-top: 12px;
}
.row1{
  width: 140px;
  height:88px;
  border-radius: 10px;
  margin-left:10px;
  margin-bottom:12px;
  line-height: 88px;
  cursor: pointer;
  text-align:right;
}
.row2{
  width: 138px;
  height:40px;
  border-radius: 10px;
  margin-left:12px;
  margin-bottom:10px;
  line-height: 40px;
  font-size: 14px;
  color:#409eff;
  cursor: pointer;
  text-align:right;
}
.row3{
  width: 103px;
  height:40px;
  border-radius: 10px;
  margin-left:12px;
  margin-bottom:10px;
  line-height: 40px;
  font-size: 14px;
  color:#409eff;
  cursor: pointer;
  text-align:right;
}
.row4{
  width: 135px;
  height:62px;
  border-radius: 10px;
  margin-left:14px;
  margin-bottom:14px;
  line-height: 62px;
  cursor: pointer;
  text-align:right;
}
.row5{
  width: 135px;
  height:88px;
  border-radius: 10px;
  margin-left:14px;
  margin-bottom:12px;
  line-height: 88px;
  cursor: pointer;
  text-align:right;
}
>>>.innerDialogs .el-dialog {
  height: unset !important;
  border-radius: unset !important;
  background: none;
  width: 100%;
  margin-top: 50px !important;
}

>>>.innerDialogs .el-dialog__wrapper{
  bottom: -80px;
}
>>>.innerDialogs .el-dialog__body {
  min-width:1100px;
  padding:  0;
}

.innerDialogs .el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}
.innerTitle{
  font-weight: bold;
  padding-bottom:20px;
  line-height: 1.6em;
  border-bottom:1px solid #ECEDED;
  color:#101010;
  font-size:20px;
}
.zhezhao {
  width:400px;
  height:670px;
  position: absolute;
  z-index: 2000;
  border-radius: 20px 0 0 20px;
  background-color: rgba(0, 0, 0, 0.3);
  top: 0;
  /*right: 0;*/
  bottom: 0;
  /*left: -360px;*/
  -webkit-transition: opacity .3s;
  transition: opacity .3s;
  margin:30px auto;
}
.xgal {
  color:#101010;
  font-size:16px;
  padding:0px 9px;
  border-left: 6px solid #FF6F36;
}
.baseEdu{
  width:760px;
  height:670px;
  background:#fff;
  border-radius: 20px;
  margin: 0 auto 30px;
  display:flex;
}
.titleDiv{
  color:#2381FE;
  font-size:14px;
  line-height: 24px;
  border-radius: 10px;
  padding:10px 20px;
  margin:10px 0;
  background-color: rgba(243, 244, 253, 1);
  cursor: pointer;
}
.imageDiv{
  width:167px;
  max-height:167px;
  margin:10px;
  border-radius: 15px;
  border: 1px solid #E8E8E8;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Education.vue